import {GCPortalkarteClass} from "./class_portalkarte";
import {GCPortalkarteEditClass} from "./class_portalkarte_edit";

declare var VERSION: string;
/**
 * @param {string} classname Welche Klasse soll erzeugt werden (map, control, simple)
 * @param {string} idname
 * @param {object} config
 */
export function factory(classname:string, idname:string, config?:object) {

    if (!config) config = {};

    console.log('Portalkarte Version:' + VERSION);

    switch(classname)
    {
        case 'simple':
        case 'map':
            return new GCPortalkarteClass(idname,config)

        case 'control':
            return new GCPortalkarteEditClass(idname,config);

    }

    console.error('Klasse "%s" wird nicht unterstützt!',classname);
    return null;
}
export {GCPortalkarteClass as GCPortalkarteClass};
export {GCPortalkarteEditClass as GCPortalkarteEditClass};